import React from 'react';

import GlobalityLabelCDS from '@sharedCR/coreDesignSystem/GlobalityLabelCDS';
import PropTypes from 'prop-types';

const WithGlobalityLabelCellContent = ({ text, isGlobal, children }) => (
  <span className="table-cell__content_text inline-flex items-center gap-4">
    <span className="tool__break-word">{text}</span>
    <GlobalityLabelCDS isGlobal={isGlobal} />
    {children}
  </span>
);

WithGlobalityLabelCellContent.propTypes = {
  text: PropTypes.string.isRequired,
  isGlobal: PropTypes.bool,
  children: PropTypes.node,
};

export default WithGlobalityLabelCellContent;
